const enum OrderVoActionType {
  SET_ORDER_VO_MENU_LOCALE = 'SET_ORDER_VO_MENU_LOCALE',
  SET_ORDER_VO_SERVETYPE = 'SET_ORDER_VO_SERVETYPE',
  SET_ORDER_VO_STATUS = 'SET_ORDER_VO_STATUS',
  SET_ORDER_VO_IS_POSTPAY = 'SET_ORDER_VO_IS_POSTPAY',
  SET_ORDER_VO_CUSTOMID = 'SET_ORDER_VO_CUSTOMID',
  SET_ORDER_VO_PREORDERTIME = 'SET_ORDER_VO_PREORDERTIME',
  SET_ORDER_VO_ADDRESS = 'SET_ORDER_VO_ADDRESS',
  SET_ORDER_VO_SEAT_OVERTIME_MINS = 'SET_ORDER_VO_SEAT_OVERTIME_MINS',
  SET_ORDER_VO_SEATED_AT = 'SET_ORDER_VO_SEATED_AT',
  SET_ORDER_VO_SEATS = 'SET_ORDER_VO_SEATS',
  SET_ORDER_VO_CONDITIONS = 'SET_ORDER_VO_CONDITIONS',
  SET_ORDER_VO_COUPON_BARCODES = 'SET_ORDER_VO_COUPON_BARCODES',
  SET_ORDER_VO_REDEEM_RULES = 'SET_ORDER_VO_REDEEM_RULES',
  SET_ORDER_VO_ORDER_ITEMS = 'SET_ORDER_VO_ORDER_ITEMS',
  SET_ORDER_VO_ORDER_PROMOTIONS = 'SET_ORDER_VO_ORDER_PROMOTIONS',
  SET_ORDER_VO_COMMENTS = 'SET_ORDER_VO_COMMENTS',
  SET_ORDER_VO_SERVICE_FEE = 'SET_ORDER_VO_SERVICE_FEE',
  SET_ORDER_VO_SHAREMEEL_FEE = 'SET_ORDER_VO_SHAREMEEL_FEE',
  SET_ORDER_VO_TOTAL = 'SET_ORDER_VO_TOTAL',
  SET_ORDER_VO_CUSTOMER_NAME = 'SET_ORDER_VO_CUSTOMER_NAME',
  SET_ORDER_VO_CUSTOMER_PHONE = 'SET_ORDER_VO_CUSTOMER_PHONE',
  SET_ORDER_VO_CUSTOMER_AREA_CODE = 'SET_ORDER_VO_CUSTOMER_AREA_CODE',
  SET_ORDER_VO_PAY_METHOD = 'SET_ORDER_VO_PAY_METHOD',
  SET_ORDER_VO_ALERTS = 'SET_ORDER_VO_ALERTS',
  SET_ORDER_VO_WAITING_INFO = 'SET_ORDER_VO_WAITING_INFO',
  SET_ORDER_VO_PAGER_CODE = 'SET_ORDER_VO_PAGER_CODE',
}

export { OrderVoActionType };
